import { NavLink, useLocation } from 'react-router-dom';
import {
  BarChart3,
  ArrowLeftRight,
  Tag,
  Users,
  Package,
  Folder,
  FileText,
  Calendar,
  CreditCard,
  Tags,
  Settings,
  X,
} from 'lucide-react';
import styles from './Sidebar.module.css';

interface SidebarProps {
  onClose?: () => void;
}

const navItems = [
  { path: '/report', label: 'Report', icon: BarChart3 },
  { path: '/movimenti', label: 'Movimenti', icon: ArrowLeftRight },
  { path: '/scadenze', label: 'Scadenze', icon: Calendar },
  { path: '/categorie', label: 'Reparti', icon: Tag },
  { path: '/rubrica', label: 'Rubrica', icon: Users },
  { path: '/articoli', label: 'Magazzino', icon: Package },
  { path: '/categorie-articoli', label: 'Merceologia', icon: Folder },
  { path: '/tipi-pagamento', label: 'Tipi Pagamento', icon: CreditCard },
  { path: '/tipi-contatto', label: 'Tipi Contatto', icon: Tags },
  { path: '/risorse', label: 'Risorse', icon: FileText },
];

const Sidebar = ({ onClose }: SidebarProps) => {
  const location = useLocation();

  return (
    <aside className={styles.sidebar} role="navigation" aria-label="Menu principale">
      {onClose && (
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Chiudi menu"
        >
          <X size={24} />
        </button>
      )}

      <nav className={styles.nav}>
        <ul className={styles.navList}>
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path ||
              location.pathname.startsWith(item.path + '/');

            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={`${styles.navLink} ${isActive ? styles.active : ''}`}
                  onClick={onClose}
                >
                  <Icon size={20} aria-hidden="true" />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className={styles.footer}>
        <NavLink
          to="/impostazioni"
          className={`${styles.navLink} ${location.pathname === '/impostazioni' ? styles.active : ''}`}
          onClick={onClose}
        >
          <Settings size={20} aria-hidden="true" />
          <span>Impostazioni</span>
        </NavLink>
      </div>
    </aside>
  );
};

export default Sidebar;
